import { Image } from "@core/components/Image/Image";
import { registerComponent } from "@selected/template/client";
import { StartLink } from "./start/start-primitives";

const cn = (...classes: Array<string | false | null | undefined>) =>
  classes.filter(Boolean).join(" ") || undefined;

registerComponent("Image", ({ className, imageClassName, ...props }: any) => (
  <Image
    {...props}
    className={cn("h-full w-full", className)}
    imageClassName={cn(imageClassName, className)}
  />
));
registerComponent("Link", StartLink);
